import { render, staticRenderFns } from "./InvestmentMaturity.vue?vue&type=template&id=6de628ee&scoped=true&"
import script from "./InvestmentMaturity.vue?vue&type=script&lang=js&"
export * from "./InvestmentMaturity.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentMaturity.vue?vue&type=style&index=0&id=6de628ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de628ee",
  null
  
)

export default component.exports